import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api";

export const GetBookings_Admin = createAsyncThunk(
  "ls/GetBookings_Admin",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/request-inspection`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);


export const GetBookings_Landlord = createAsyncThunk(
  "ls/GetBookings_Admin",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/booking/landlord/bookings`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAbooking = createAsyncThunk(
  "ls/GetAbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/apartments/${payload}`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetASearchedbooking = createAsyncThunk(
  "ls/GetASearchedbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    // console.log({ payload });
    const {
      type_of_property,
      location,
      rent_per_annum,
      page,
      limit,
      navigate,
    } = payload;
    try {
      const response = await api.get(`/apartments`, {
        params: {
          type_of_property,
          location,
          rent_per_annum,
          page,
          limit,
        },
      });
      navigate("/result");
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeleteAbooking = createAsyncThunk(
  "ls/DeleteAbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.delete(`/apartments/${payload}`, payload);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createbooking = createAsyncThunk(
  "ls/createbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.post(`/apartments`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response?.data?.message);
      // redirectUser(VERIFY_OTP);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatebooking = createAsyncThunk(
  "ls/createbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const appURL = new URLSearchParams(window.location.search);
    try {
      const response = await api.put(
        `/apartments/${appURL.get("booking")}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deletebookingImage = createAsyncThunk(
  "ls/DeleteAbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const appURL = new URLSearchParams(window.location.search);

    try {
      const response = await api.put(
        `/apartments/${appURL.get("booking")}/remove/images`,
        {
          name: payload,
        }
      );
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const markbookingAsOccupied = createAsyncThunk(
  "ls/DeleteAbooking",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const appURL = new URLSearchParams(window.location.search);
    // console.log(appURL.get("booking"));
    try {
      const response = await api.put(`/apartments/update/market/${payload}`, {
        market_status: "occupied",
      });
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  booking: {},
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    selectedbooking(state, action) {
      return {
        ...state,
        selected_booking: action.payload,
      };
    },

    createAppbooking(state, action) {
      return {
        ...state,
        created_booking: action.payload,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetBookings_Admin.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetBookings_Admin.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          bookings: action.payload,
        };
      })
      .addCase(GetBookings_Admin.rejected, (state, action) => {
        return {
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetAbooking.pending, (state) => {
        return {
          ...state,
          isLoadingbooking: true,
        };
      })
      .addCase(GetAbooking.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingbooking: false,
          isSuccessful: true,
          booking: action.payload,
        };
      })
      .addCase(GetAbooking.rejected, (state, action) => {
        return {
          isLoadingbooking: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetASearchedbooking.pending, (state) => {
        return {
          ...state,
          isLoadingbooking: true,
        };
      })
      .addCase(GetASearchedbooking.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingbooking: false,
          isSuccessful: true,
          booking: action.payload,
        };
      })
      .addCase(GetASearchedbooking.rejected, (state, action) => {
        return {
          isLoadingbooking: false,
          error: action.payload,
        };
      });

    builder
      .addCase(DeleteAbooking.pending, (state) => {
        return {
          ...state,
          isDeleting: true,
        };
      })
      .addCase(DeleteAbooking.fulfilled, (state, action) => {
        return {
          ...state,
          isDeleting: false,
          isSuccessful: true,
          deleted_bookings: action.payload,
        };
      })
      .addCase(DeleteAbooking.rejected, (state, action) => {
        return {
          ...state,
          isDeleting: false,
          error: action.payload,
        };
      });

    builder
      .addCase(createbooking.pending, (state) => {
        return {
          ...state,
          isCreating: true,
        };
      })
      .addCase(createbooking.fulfilled, (state, action) => {
        return {
          ...state,
          isCreating: false,
          isSuccessful: true,
          create_booking: action.payload,
        };
      })
      .addCase(createbooking.rejected, (state, action) => {
        return {
          ...state,
          isCreating: false,
          error: action.payload,
        };
      });
  },
});

export const { selectedbooking, createAppbooking } = bookingSlice.actions;

export default bookingSlice.reducer;
